// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";

function generatePayoad(allowedUserAction, newPriority, changedStatus, activeTab) {
  switch (allowedUserAction) {
    case /* All */0 :
        return ;
    case /* ChangePriority */1 :
        if (newPriority !== undefined) {
          return {
                  campaigns: List.mapi((function (index, campaign) {
                          return {
                                  campaign_id: campaign.id,
                                  action: undefined,
                                  pending_priority: index + 1 | 0
                                };
                        }), newPriority)
                };
        } else {
          return ;
        }
    case /* ChangeStatus */2 :
        if (changedStatus !== undefined) {
          if (activeTab) {
            return {
                    campaigns: List.map((function (campaign) {
                            var match = campaign.campaign_status;
                            var tmp;
                            switch (match) {
                              case /* Deactivate */0 :
                                  tmp = "deactivate";
                                  break;
                              case /* Delete */1 :
                                  tmp = "delete";
                                  break;
                              case /* Approve */2 :
                                  tmp = "approve";
                                  break;
                              case /* Discard */3 :
                                  tmp = "reject";
                                  break;
                              
                            }
                            return {
                                    campaign_id: campaign.campaign_id,
                                    action: tmp,
                                    pending_priority: undefined
                                  };
                          }), changedStatus)
                  };
          } else {
            return {
                    campaigns: List.map((function (campaign) {
                            var match = campaign.campaign_status;
                            var tmp;
                            switch (match) {
                              case /* Deactivate */0 :
                                  tmp = "deactivate";
                                  break;
                              case /* Delete */1 :
                                  tmp = "delete";
                                  break;
                              case /* Approve */2 :
                                  tmp = "approve";
                                  break;
                              case /* Discard */3 :
                                  tmp = "reject";
                                  break;
                              
                            }
                            return {
                                    campaign_id: campaign.campaign_id,
                                    action: tmp,
                                    pending_priority: undefined
                                  };
                          }), changedStatus)
                  };
          }
        } else {
          return ;
        }
    
  }
}

export {
  generatePayoad ,
  
}
/* No side effect */
